import { render } from "./SkeletonBlock.vue?vue&type=template&id=16fb513f"
import script from "./SkeletonBlock.vue?vue&type=script&lang=js"
export * from "./SkeletonBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__